import { motion } from "framer-motion";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { profileData } from "../data/profileData";
import { BsGithub, BsLink45Deg } from "react-icons/bs";
import amsImage from "../assets/images/ams-01.png";
import eeImage from "../assets/images/ee-01.png";
import taskImage from "../assets/images/taskmanager.jpg";

const imageMap = {
	"taskmanager.jpg": taskImage,
	"ams-01.png": amsImage,
	"ee-01.png": eeImage,
};

const ProjectCard = ({ project }) => {
	const itemVariants = {
		hidden: { opacity: 0, scale: 0.9 },
		visible: {
			opacity: 1,
			scale: 1,
			transition: { duration: 0.5 },
		},
	};

	return (
		<motion.article className="project-card" variants={itemVariants}>
			<div className="project-card-image-wrapper">
				<img src={imageMap[project.image]} alt={project.title} />
				<div className="project-card-overlay">
					<div className="project-card-overlay-content">
						<h3>{project.title}</h3>
						<p>{project.summary}</p>
						<div className="project-card-links">
							<a
								href={project.github}
								target="_blank"
								rel="noopener noreferrer"
								className="project-link"
								title="View on GitHub"
							>
								<BsGithub /> Code
							</a>
							{project.demo && (
								<a
									href={project.demo}
									target="_blank"
									rel="noopener noreferrer"
									className="project-link"
									title="View Live Demo"
								>
									<BsLink45Deg /> Demo
								</a>
							)}
						</div>
					</div>
				</div>
			</div>
			<div className="project-card-body">
				<div className="project-card-header">
					<span className="project-type">{project.category}</span>
				</div>
				<h3>{project.title}</h3>
				<p>{project.summary}</p>
				<div className="project-tech">
					{project.tech &&
						project.tech.map((tech) => (
							<span key={tech} className="tech-badge">
								{tech}
							</span>
						))}
				</div>
			</div>
		</motion.article>
	);
};

const Projects = () => {
	const { ref, inView } = useScrollAnimation();

	const containerVariants = {
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
			transition: { staggerChildren: 0.15 },
		},
	};

	const headerVariants = {
		hidden: { opacity: 0, y: 20 },
		visible: {
			opacity: 1,
			y: 0,
			transition: { duration: 0.5 },
		},
	};

	return (
		<section id="projects" className="section-card" ref={ref}>
			<motion.div
				initial="hidden"
				animate={inView ? "visible" : "hidden"}
				variants={containerVariants}
			>
				<motion.div className="section-header" variants={headerVariants}>
					<span>Projects</span>
					<h2>Selected work</h2>
				</motion.div>
				<motion.div className="project-grid" variants={containerVariants}>
					{profileData.projects.map((project) => (
						<ProjectCard key={project.title} project={project} />
					))}
				</motion.div>
			</motion.div>
		</section>
	);
};

export default Projects;
